import { z } from 'zod';

export enum ProcessPaymentFormField {
    CustomerId = 'customerId',
    BillId = 'billId',
    ServiceOrderId = 'serviceOrderId',
    CurrencyCode = 'currencyCode',
    Amount = 'amount',
    InvoiceIds = 'invoiceIds',
    PaymentPlanId = 'paymentPlanId',
    Notes = 'notes',
}

export const CommonProcessPaymentInvoiceIdsSchema = z.object({
    [ProcessPaymentFormField.InvoiceIds]: z.array(z.string()).nullish(),
});

export const CommonProcessPaymentFormSchema = CommonProcessPaymentInvoiceIdsSchema.extend({
    [ProcessPaymentFormField.CustomerId]: z.string(),
    [ProcessPaymentFormField.BillId]: z.string().nullish(),
    [ProcessPaymentFormField.ServiceOrderId]: z.string().nullish(),
    [ProcessPaymentFormField.CurrencyCode]: z.string(),
    [ProcessPaymentFormField.Amount]: z.number().gt(0),
    [ProcessPaymentFormField.PaymentPlanId]: z.string().nullish(),
    [ProcessPaymentFormField.Notes]: z.string().nullish(),
});

export type CommonProcessPaymentFormModel = z.infer<typeof CommonProcessPaymentFormSchema>;
export type CommonProcessPaymentInvoiceIdsModel = z.infer<typeof CommonProcessPaymentInvoiceIdsSchema>;
